module.exports = __webpack_public_path__ + "static/media/blue-dots.220197e5.png";